import axios from 'axios';
import { apiURL } from '../config/default';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params, headers }) => {
    try {
      // console.log("data",data)
      // 1. Read token from storage (matches your existing setup)
      const token = localStorage.getItem('token');
      
      // 2. Set custom header 'x-auth-token' as per your requirement
      const authHeaders = token ? { 'x-auth-token': token } : {};

      // 3. Fire request with Axios
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        // Merge auth headers with any specific headers from the endpoint
        headers: { ...authHeaders, ...headers }, 
      });

      // console.log("result",result)

      return { data: result?.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;